import React, { useEffect, useState } from "react";

import {
    View,
    Text,
    Platform,
    TouchableOpacity,
    Image
} from "react-native";
import AppTheme from "../../utils/Theme";
import User from "../../data/user/User";
import { APP_MENU_SCREENS } from "./Menu";
import Fonts from "../../Theme/Fonts";
import Colors from "../../Theme/Colors";
import i18n from "../../utils/Localization/Localization";

interface MenuCellProps {
    width: number;
    menuScreenId: APP_MENU_SCREENS;
    onSelectedMenuChange: (selectedMenuId: APP_MENU_SCREENS) => void;
    isSelected: boolean;
}

const MenuCell = (props: MenuCellProps) => {
    const { width, menuScreenId, onSelectedMenuChange } = props;

    const appTheme: AppTheme = new AppTheme();
    const user: User = User.getInstance();

    let marginBottom: number = 0;
    let iconContainerWidth: number = Platform.OS === "web" ? width : Math.floor((width - appTheme.pixelPerfect(36)) / 5);
    if (iconContainerWidth > appTheme.pixelPerfect(68)) {
        iconContainerWidth = appTheme.pixelPerfect(68);
    }
    let iconContainerHeight: number = appTheme.pixelPerfect(56);
    if ((Platform.OS === "web") && (appTheme.getFlexDirectionForSplitScreen() === "row")) {
        iconContainerWidth = appTheme.pixelPerfect(70);
        iconContainerHeight = appTheme.pixelPerfect(80);
        marginBottom = appTheme.pixelPerfect(20);
    }

    const iconSize: number = iconContainerHeight - appTheme.pixelPerfect(20);
    if (menuScreenId === "EMPTY") {
        return <View style={{ width: iconSize, height: iconSize }} />
    }
    let iconTitle: string = "Activités";
    let icon: number = require("../../assets/img/navigation/nav_icon_activite.png");
    //const levelTitle: string = user.profile === "teacher" ? i18n.t("levels." + user.children_level) : i18n.t("filters." + user.children_level);
    if (menuScreenId === "SEQUENCES") {
        icon = require("../../assets/img/navigation/nav_icon_sequences.png");
        iconTitle = "Parcours";
        if (user.profile === "family") {
            //iconTitle = `${iconTitle}\n${levelTitle}`;
        } else if (user.profile === "animator") {
            iconTitle = "Projets"
        } else if (user.profile === "teacher") {
            iconTitle = "Séquences"
        }
    } else if (menuScreenId === "ROOM") {
        if (user.profile === "teacher") {
            iconTitle = "Profs";
            icon = require("../../assets/img/navigation/nav_icon_salle_profs.png");
        } else {
            if (user.profile === "animator") {
                iconTitle = "Anims";
            } else if (user.profile === "family") {
                 iconTitle = "Parents";
            }
           
            icon = require("../../assets/img/navigation/nav_icon_coin_parents_et_animateurs.png");
        }
    } else if (menuScreenId === "SUB") {
        icon = require("../../assets/img/navigation/nav_icon_premium.png");
    } else if (menuScreenId === "ACCOUNT") {
        icon = require("../../assets/img/navigation/nav_icon_mon_compte.png");
        iconTitle = "Profil";
    } else if (menuScreenId === "PREMIUM") {
        icon = require("../../assets/img/navigation/nav_icon_premium.png");
        iconTitle = "Premium";
    } else if (menuScreenId === "ACTIVITIES") {
        //iconTitle = `${iconTitle}\n${levelTitle}`;
    }
    return <TouchableOpacity key={menuScreenId} disabled={Platform.OS === "web" ? false : props.isSelected} onPress={() => onSelectedMenuChange(menuScreenId)} style={{ marginBottom, backgroundColor: "#FFFFFF", width: iconContainerWidth, height: iconContainerHeight, justifyContent: "flex-end", alignItems: "center" }}>
        <View style={{ borderRadius: 14, width: iconSize, height: iconSize, backgroundColor: props.isSelected ? appTheme.daySkyColor : "#FFFFFF", justifyContent: "center", alignItems: "center" }}>
            <Image source={icon} style={{ width: iconSize, height: iconSize }} />
        </View>
        <Text style={{ fontFamily: Fonts.primary.bold, fontSize: Platform.OS === "web" ? 18 : 12, color: Colors.darkBlue, textAlign: "center" }}>{iconTitle}</Text>
    </TouchableOpacity>
}

export default MenuCell;